import { getGuidanceDetectionInFlight, setGuidanceDetectionInFlight } from "./gpuProbeCache";
import { type GuidanceSnapshot } from "./guidanceModel";
import { getGuidanceSnapshot, setGuidanceSnapshot } from "./guidanceStore";
import { runGpuDetection } from "./runGpuDetection";

/**
 * Returns the current guidance snapshot, starting a detection run if none exists.
 * Concurrent callers share one in-flight `runGpuDetection` promise.
 */
export async function ensureGuidanceSnapshot(enabled: boolean): Promise<GuidanceSnapshot | null> {
    if (!enabled) {
        return getGuidanceSnapshot();
    }

    const existing = getGuidanceSnapshot();
    if (existing) {
        return existing;
    }

    let inFlight = getGuidanceDetectionInFlight();
    if (!inFlight) {
        inFlight = runGpuDetection({ enabled: true })
            .then((snapshot) => {
                if (snapshot) {
                    setGuidanceSnapshot(snapshot);
                }
                return snapshot;
            })
            .finally(() => {
                setGuidanceDetectionInFlight(null);
            });
        setGuidanceDetectionInFlight(inFlight);
    }

    return inFlight;
}
